import {
    RESOURCES_REQUESTED,
    RESOURCES_SUCCEEDED,
    RESOURCES_FAILED,
} from './constants';

const initialState = {
    //initialized resources object
    resources: null,
    //error in resources are assigned to this 'error' object
    error: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case RESOURCES_REQUESTED: {
            return {
                ...state,
            };
        }
        case RESOURCES_SUCCEEDED: {
            const { resources } = action;
            return {
                ...state,
                resources,
            };
        }
        case RESOURCES_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
            };
        }
        default:
            return state;
    }
}
